const EMPTY_ARRAY = Object.freeze([]);
const EMPTY_OBJECT = Object.freeze({});

export { EMPTY_ARRAY, EMPTY_OBJECT };
